const communications = {
  communications:'Communications',
  unprocessedCommunications:'Unprocessed Communications',
  startCall:'Call',
  sendMessage:'Send Message',
  conversation:'Conversation',
  SMS:'SMS',
  reminder:'Reminder',
  call:'Call',
  dashboardView:'Dashboard View',
  callPlanned:'Calls Planned',
  populateWaitingRoom:'Populate Waiting Room',
  start:'Start',
  communicationType:'Communication Type',
  message:'Message',
  comment:'Comment',
  voiceMail:'Voice Mail',
  sent:'Sent',
  mail:'Mail',

  communicationsModal:{
    from:'From',
    subject:'Subject',
    to:'To',
    patient:'Patient',
    staff:'Staff',
    messageCategory:'Message Category',
    priority:'Priority',
    message:'Message',
    reply:'Reply',
    messageType:'Message Type',
    type:'Type',
    email:'Email',
    sms:'SMS',
    call:'Call',
    reminder:'Reminder',
    heading:'Heading',
  }
}


export default communications
